'use strict';

import { newModalFromString } from './components/modal';
import { appendToUrl } from './util/common';
import Plugins from './util/plugins';
import NotifyHelper from './product/notify';
import { modalQuickAdd } from './quickAdd';
import Product from './product/detail';
import { applyRendering } from './util/render';

class OrderAgain {
    constructor () {
        this.orderAgainClassName = '.js-orderAgain';
        this.orderAgainClassCarousel = '.js-orderAgain-carousel';
        this.orderAgainClassCartCarousel = '.js-orderAgain-cartCarousel';
        this.orderAgainClassCartCarouselContainer = '.js-orderAgain-cartCarousel__container';
        this.orderAgainClassCartCarouselList = '.js-orderAgain-cartCarousel__list';
        this.orderAgainClassCarouselItem = '.js-orderAgain-carousel__item';
        this.orderAgainClassModalColors = '.js-orderAgain-modal__colorSwatch-link';
        this.orderAgainClassModalSizes = '.js-orderAgain-modal__sizeOption-link';
        this.orderAgainClassAddToCartButton = '.js-orderAgain-modal__addToCartButton';
        this.orderAgainClassQuantityInput = '.js-orderAgain-modal__quantitySelector';
        this.orderAgainCarouselContainerSelector = '.js-orderAgain-carousel__container';
        this.customPrevSelector = '.js-custom-prev';
        this.customNextSelector = '.js-custom-next';
        this.orderAgainClassOrderDetailsItem = '.js-orderAgain-orderDetails__item';
        this.orderAgainClassBuyAgainPage = '.js-orderAgain-showPage';
        this.orderAgainClassFilterSelect = '.js-orderAgain-filter__select';
        this.orderAgainClassProductsContainer = '.js-orderAgain-page__productsContainer';
        this.orderAgainClassCartTab = '.js-orderAgain-cartTab__container';
        this.orderAgainClassCartTabItemLink = '.js-orderAgain-cartTab__item-link';
        this.orderAgainClassProductDetails = '.js-orderAgain-productDetails__label';
        this.orderAgainClassSeeSimilarPage = '.js-orderAgain-seeSimilarPage__container';
        this.modalTitleIdPrefix = 'orderAgainModalTitle';
        this.modalTitleCounter = 0;

        this.isCarouselListenersLoaded = false;
    }

    run () {
        if ($(this.orderAgainClassName).length) {
            const carouselUrl = $(this.orderAgainClassName).data('url');
            if (carouselUrl) {
                const $carouselContainer = $(this.orderAgainClassCarousel);
                if ($carouselContainer.length !== 0) {
                    this.loadCarousel(carouselUrl, $carouselContainer);
                    this.addCarouselListeners();
                }
            }
        }

        if ($(this.orderAgainClassCartCarousel).length) {
            const carouselUrl = $(this.orderAgainClassCartCarousel).data('url');
            if (carouselUrl) {
                const $carouselContainer = $(this.orderAgainClassCartCarouselContainer);
                if ($carouselContainer.length !== 0) {
                    this.loadCartCarousel(carouselUrl, $carouselContainer);
                }
            }
        }

        if ($(this.orderAgainClassOrderDetailsItem).length) {
            const orderDetailsButtonUrl = $(this.orderAgainClassOrderDetailsItem).first().data('url');
            if (orderDetailsButtonUrl) {
                const $orderDetailsItems = $(this.orderAgainClassOrderDetailsItem);
                this.loadOrderDetailsButtons(orderDetailsButtonUrl, $orderDetailsItems);
                this.addCarouselListeners();
                Product.run();
            }
        }

        const hasBuyAgainPage = $(this.orderAgainClassBuyAgainPage).length > 0;
        const hasCartTab = $(this.orderAgainClassCartTab).length > 0;

        if (hasBuyAgainPage || hasCartTab) {
            this.orderAgainPageListeners();
            this.addCarouselListeners();
        }

        if (hasBuyAgainPage) {
            this.initFilterSelectionLabel();
        }

        if (hasCartTab) {
            const cartTabContainerUrl = $(this.orderAgainClassCartTab).data('url');
            if (cartTabContainerUrl) {
                this.showCartTab(cartTabContainerUrl);
            }
        }

        const $productDetailsContainer = $(this.orderAgainClassProductDetails);
        if ($productDetailsContainer.length) {
            const productDetailsUrl = $productDetailsContainer.data('url');
            if (productDetailsUrl) {
                this.addProductDetailsListeners($productDetailsContainer, productDetailsUrl);
            }
        }

        const $seeSimilarContainer = $(this.orderAgainClassSeeSimilarPage);
        if ($seeSimilarContainer.length) {
            Product.run();
        }
    }

    loadCarousel (url, $carouselContainer) {
        $.ajax(url).then((data) => {
            $carouselContainer.html(data || '');
            this._initOrderItAgainCarousel();
        });
    }

    loadCartCarousel (url, $carouselContainer) {
        const _self = this;
        $.ajax(url).then((data) => {
            if (data && data.trim().length > 0) {
                $('.js-cart-recommendations').addClass('hide');
                $carouselContainer.html(data);

                const $cartCarousel = $carouselContainer.find(_self.orderAgainClassCartCarouselList);

                $cartCarousel.slick({
                    slide: '.product',
                    dots: false,
                    infinite: false,
                    speed: 700,
                    cssEase: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
                    easing: 'linear',
                    useCSS: true,
                    useTransform: true,
                    draggable: false,
                    swipe: false,
                    touchMove: false,
                    swipeToSlide: false,
                    touchThreshold: 8,
                    variableWidth: false,
                    adaptiveHeight: false,
                    slidesToShow: 4.58,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: $carouselContainer.find('.js-custom-prev'),
                    nextArrow: $carouselContainer.find('.js-custom-next'),
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2.5,
                            slidesToScroll: 1,
                            infinite: false,
                            draggable: true,
                            swipe: true,
                            touchMove: true,
                            swipeToSlide: true,
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1.5,
                            slidesToScroll: 1,
                            infinite: false,
                            draggable: true,
                            swipe: true,
                            touchMove: true,
                            swipeToSlide: true,
                        }
                    }]
                });

                const $prev = $carouselContainer.find('.js-custom-prev');
                const $next = $carouselContainer.find('.js-custom-next');
                const updateCartButtonStates = this._carouselButtonsUpdater($cartCarousel, $prev, $next);

                $cartCarousel.on('afterChange cartCarousel:updateButtons', updateCartButtonStates);
                updateCartButtonStates();

                $('body').trigger('listing:orderAgainItems', {
                    container: _self.orderAgainClassCartCarouselList,
                    type: 'buy_it_again'
                });
            } else {
                $('.js-cart-recommendations').removeClass('invisible');
            }
        });
    }

    addCarouselListeners () {
        if (this.isCarouselListenersLoaded) {
            return;
        }
        this.isCarouselListenersLoaded = true;

        const _self = this;
        // Carousel item click listener
        $('body').on('click', this.orderAgainClassCarouselItem, (e) => {
            e.preventDefault();

            let url = $(e.currentTarget).data('url');
            if (!url) {
                return;
            }

            const analyticsType = $(e.currentTarget).data('analytics-type');

            $.spinner().start();
            $.ajax(url)
                .then((data) => {
                    $.spinner().stop();
                    const modal = newModalFromString(data, false, ['cc-orderAgain-modal', 'analytics-order-again']);
                    $(modal.modalBox).addClass('rightModalAttribute');
                    // Add dialog semantics for accessibility
                    _self._setDialogA11y(modal);
                    modal.open();
                    _self._addModalListeners(modal);
                    _self._initColorSwatchesCarousel(modal);
                    _self._initModalFocus(modal, $(e.currentTarget));
                    _self._addSizePreselection(modal);

                    const target = $(modal.modalBox).find('.analytics.product');
                    const position = parseInt($(modal.modalBox).find(this.orderAgainClassAddToCartButton).data('position')) || 0;

                    if (analyticsType === 'similar_products') {
                        $('body').trigger('analytics:similarProductModalOpened', {
                            container: '.js-orderAgain-seeSimilarModal',
                            type: 'similar_products'
                        });
                    } else {
                        $('body').trigger('analytics:orderAgainModalOpened', {
                            target: target,
                            index: position,
                        });
                    }
                })
                .fail(() => {
                    $.spinner().stop();
                });
        });
    }

    _setDialogA11y (modal) {
        const $box = $(modal.modalBox);
        $box.attr({ role: 'dialog', 'aria-modal': 'true' });
        const $title = $box.find('h2').first();
        if ($title.length) {
            if (!$title.attr('id')) {
                this.modalTitleCounter += 1;
                $title.attr('id', `${this.modalTitleIdPrefix}-${this.modalTitleCounter}`);
            }
            $box.attr('aria-labelledby', $title.attr('id'));
        }
    }

    _initModalFocus (modal, $trigger) {
        // Blur the element that opened the modal (so focus leaves carousel context)
        if ($trigger && $trigger.length) {
            $trigger.blur();
        }

        const $close = $(modal.modalBox).find('.js-orderAgain-modal__closeIcon');
        const focusClose = () => {
            if ($close.length) {
                $close[0].focus({ preventScroll: true });
            }
        };

        // Small delay to cover modal animation timing
        const raf = window.raf || window.requestAnimationFrame;
        if (typeof raf === 'function') {
            raf(focusClose);
        } else {
            setTimeout(focusClose, 100);
        }
        this._enableModalFocusTrap(modal, $trigger);
    }

    _enableModalFocusTrap (modal, $trigger) {
        const selector =
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
        const $modalBox = $(modal.modalBox);

        const keydownHandler = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                modal.close();
                $modalBox.off('keydown.orderAgainFocusTrap');
                if ($trigger && $trigger.length) {
                    $trigger[0].focus({ preventScroll: true });
                }
                return;
            }
            if (e.key !== 'Tab') return;

            const $focusables = $modalBox.find(selector).filter(':visible');
            if (!$focusables.length) return;

            const first = $focusables.get(0);
            const last = $focusables.get($focusables.length - 1);
            const active = document.activeElement;

            // Shift + Tab on first -> go to last
            if (e.shiftKey && active === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && active === last) {
                e.preventDefault();
                first.focus();
            }
        };
        $modalBox.on('keydown.orderAgainFocusTrap', keydownHandler);

        $modalBox.find('.js-orderAgain-modal__closeIcon').one('click', () => {
            $modalBox.off('keydown.orderAgainFocusTrap');
            if ($trigger && $trigger.length) {
                $trigger[0].focus({ preventScroll: true });
            }
        });
    }

    _initOrderItAgainCarousel () {
        const $container = $(this.orderAgainCarouselContainerSelector);
        if ($container.hasClass('slick-initialized')) {
            $container.slick('unslick');
        }

        const $carousel = $container.slick({
            slidesToShow: 4.78,
            slidesToScroll: 1,
            autoplay: false,
            dots: false,
            arrows: false,
            draggable: false,
            swipe: false,
            touchMove: false,
            swipeToSlide: false,
            infinite: false,
            responsive: [
                {
                    // Large tablet: allow partial drag if desired
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4.2,
                        swipe: true,
                        draggable: true,
                        touchMove: true,
                        swipeToSlide: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3.5,
                        swipe: true,
                        draggable: true,
                        touchMove: true,
                        swipeToSlide: true,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2.43,
                        slidesToScroll: 1,
                        swipe: true,
                        draggable: true,
                        touchMove: true,
                        swipeToSlide: true,
                    },
                },
            ],
        });

        const $wrapper = $carousel.closest(this.orderAgainClassCarousel);
        $wrapper.addClass('cc-orderAgain-carousel_show');

        const $prev = $wrapper.find(this.customPrevSelector);
        const $next = $wrapper.find(this.customNextSelector);

        const $controls = $wrapper.find('.cc-orderAgain-carousel__controls');
        const updateButtonStates = this._carouselButtonsUpdater($carousel, $prev, $next, $controls);

        $prev.off('click.orderAgain').on('click.orderAgain', () => {
            $carousel.slick('slickPrev');
            updateButtonStates();
        });
        $next.off('click.orderAgain').on('click.orderAgain', () => {
            $carousel.slick('slickNext');
            updateButtonStates();
        });

        $carousel.on('afterChange', updateButtonStates);
        updateButtonStates();

        $('body').trigger('listing:orderAgainItems', {
            container: '.js-orderDetails-products__container',
            type: 'buy_it_again'
        });
    }

    _carouselButtonsUpdater ($carousel, $prev, $next, $controls = null) {
        return () => {
            if (!$carousel.hasClass('slick-initialized')) {
                $prev.prop('disabled', true);
                $next.prop('disabled', true);
                if ($controls) {
                    $controls.addClass('hide').attr('aria-hidden', 'true');
                }
                return;
            }

            const current = $carousel.slick('slickCurrentSlide');
            const slickInstance = $carousel.slick('getSlick');
            const totalSlides = slickInstance.slideCount;
            const shown = slickInstance.options.slidesToShow;
            const fractional = shown % 1 !== 0;
            const effectiveShown = fractional ? Math.floor(shown) : shown;
            let maxIndexBeforeDisable = totalSlides - effectiveShown;
            if (maxIndexBeforeDisable < 0) {
                maxIndexBeforeDisable = 0;
            }

            $prev.prop('disabled', current <= 0);
            $next.prop('disabled', current >= maxIndexBeforeDisable);

            if ($controls) {
                const bothDisabled = $prev.prop('disabled') && $next.prop('disabled');
                $controls.toggleClass('hide', bothDisabled).attr('aria-hidden', bothDisabled ? 'true' : 'false');
            }
        };
    }

    _addSizePreselection (modal) {
        const preselectedSize = $(modal.modalBox).find(this.orderAgainClassAddToCartButton).data('purchased-size') || null;
        if (preselectedSize) {
            const $preselectedSizeOption = $(modal.modalBox).find(`${this.orderAgainClassModalSizes}[data-attr-value="${preselectedSize}"]`);
            if ($preselectedSizeOption.length && $preselectedSizeOption.hasClass('selectable')) {
                $preselectedSizeOption.trigger('click');
            }
        }
    }

    _addModalListeners (modal) {
        const _self = this;

        // Modal close
        $(modal.modalBox).find('.js-orderAgain-modal__closeIcon').on('click', () => {
            modal.close();
        });

        // Color and size selection event listener
        $(modal.modalBox).on('click', `${this.orderAgainClassModalColors}, ${this.orderAgainClassModalSizes}`, (e) => {
            e.preventDefault();

            const type = $(e.currentTarget).hasClass('js-orderAgain-modal__colorSwatch-link') ? 'color' : 'size';

            const isSizeSelection = $(e.currentTarget).data('product-attr') === 'size';
            const isUnavailableSize = isSizeSelection && $(e.currentTarget).hasClass('unselectable');
            if (isUnavailableSize) {
                // Notify me management
                const $notifyMeContainer = $(modal.modalBox).find('.js-orderAgain-modal__sizeOptions');
                const isNotifyMeEnabled = $notifyMeContainer.data('is-notify-me-enabled');
                if (!isNotifyMeEnabled) {
                    return;
                }
                const notifyMeUrl = $notifyMeContainer.data('notify-me-url');
                const $currentTarget = $(e.currentTarget);
                return _self._showNotifyMeModal($currentTarget, notifyMeUrl, modal);
            }

            const url = $(e.currentTarget).data('url');
            if (!url) {
                return;
            }

            const productVariationUrl = appendToUrl(url, {
                isOrderAgainProduct: true
            });

            $.spinner().start();
            $.ajax(productVariationUrl).then((data) => {
                $.spinner().stop();

                const product = data.product;
                _self._updateModalGeneralInfo(modal, product, isSizeSelection);

                // Update variation attributes
                for (let i = 0; i < product.variationAttributes.length; i++) {
                    let attr = product.variationAttributes[i];
                    if (attr.swatchable) {
                        _self._updateModalColorSwatches(modal, attr);
                    } else {
                        _self._updateModalSizeOptions(modal, product, attr);
                    }
                }

                $('body').trigger('analytics:orderAgainAfterAttributeSelect', {
                    data: data,
                    type: type,
                    itemListName: 'buy_it_again',
                    itemListId: $('.page').data('action') === 'Cart-Show' ? 'cart' : 'my_orders_and_returns'
                });
            }).fail(() => {
                $.spinner().stop();
            });
        });

        // Quantity change listener
        $(modal.modalBox).on('click', `${this.orderAgainClassQuantityInput} .quantity-circle`, (e) => {
            e.preventDefault();

            const $quantityContainer = $(modal.modalBox).find(`${this.orderAgainClassQuantityInput}`);
            const $quantitySelectInput = $quantityContainer.find('select[name="quantity"]');
            const isIncrease = $(e.currentTarget).data('action') === 'increase';
            const isDecrease = $(e.currentTarget).data('action') === 'decrease';
            const currentQuantity = parseInt($quantitySelectInput.val()) || 1;

            let newQuantity = null;
            if (isIncrease) {
                newQuantity = currentQuantity + 1;
            } else if (isDecrease && currentQuantity > 1) {
                newQuantity = currentQuantity - 1;
            } else {
                return;
            }

            _self._updateQuantity($quantityContainer, $quantitySelectInput, newQuantity);
        });

        // Add to cart
        $(modal.modalBox).on('click', this.orderAgainClassAddToCartButton, (e) => {
            e.preventDefault();
            const url = $(e.currentTarget).data('url');
            if (!url) {
                return;
            }

            const pid = $(e.currentTarget).data('pid');
            if (!pid) {
                return;
            }

            const currentQuantity = parseInt($(`${this.orderAgainClassQuantityInput} select[name="quantity"]`).val()) || 1;
            const itemListId = $('.page').data('action') === 'Cart-Show' ? 'cart' : 'my_orders_and_returns';
            const position = parseInt($(e.currentTarget).data('position')) || 0;
            const form = {
                pid: pid,
                quantity: currentQuantity,
                isOrderAgainProduct: true,
                GTMItemListName: 'buy_it_again',
                GTMItemListId: itemListId,
                GTMIndex: position
            };

            const $productContainer = $(modal.modal);
            const $analyticsContainer = $(modal.modalBox).find('.analytics.productListingItem').data();

            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: form,
                success: data => {
                    $.spinner().stop();
                    if (!data.error) {
                        if (modal && modal.modal) {
                            modal.close();
                        }
                        $('body').trigger('product:afterAddToCart', {
                            ...data,
                            form,
                            listingType: 'buy_it_again',
                            $productContainer,
                            $analyticsContainer
                        });
                        $('.minicart').trigger('count:update', data);

                        if ($('.page').data('action') === 'Cart-Show') {
                            location.reload();
                        }
                    }
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });

        $('body').off('click', '.js-quick-add');
        modalQuickAdd();

        $('body').on('product:afterAddToCart', () => {
            if (modal && modal.modal) {
                modal.close();
            }
        });
    }

    _updateModalGeneralInfo (modal, product, isSizeSelection) {
        if (!isSizeSelection) {
            // Update image
            if (product.images.large && product.images.large.length > 0) {
                $(modal.modalBox)
                    .find('[data-product-attr="image"]')
                    .attr('src', product.images.large[0].url);
            }
        }

        // Update product url
        $(modal.modalBox)
            .find('[data-product-attr="url"]')
            .attr('href', product.url);

        // Update product ID to add to cart button
        $(modal.modalBox)
            .find('[data-product-attr="addToCartButton"]')
            .data('pid', product.id)
            .attr('data-pid', product.id);

        // Toggle product promotions callout
        $(modal.modalBox)
            .find('[data-product-attr="promotions"]')
            .toggleClass('hide', (product.isSoldout || product.comingSoon || !product.promotions || product.promotions.length === 0 || !product.promotions[0].name));

        // Update product promotions callout message
        if (product.promotions && product.promotions.length > 0) {
            const promoMessage = product.promotions[0].name || '';
            $(modal.modalBox)
                .find('[data-product-attr="promotions"]')
                .empty().html(promoMessage);
        }

        // Update product returned label
        const displayReturnedProductLabel = product.orderAgainData && product.orderAgainData.returned;
        $(modal.modalBox)
            .find('[data-product-attr="returnedProductLabel"]')
            .toggleClass('hide', !displayReturnedProductLabel);
    }

    _updateModalColorSwatches (modal, attr) {
        for (let j = 0; j < attr.values.length; j++) {
            let attrValue = attr.values[j];

            // Update selected color label
            if (attrValue.selected) {
                $(modal.modalBox)
                    .find(`[data-product-attr="selectedColor"]`)
                    .text(`${attrValue.value + ' - ' + attrValue.displayValue}`);
            }

            // Update current color swatch selection
            const $swatchWrapper = $(modal.modalBox)
                .find(`[data-product-attr="color"][data-attr-value="${attrValue.value}"]`);

            // Update current color swatch selection + ARIA state
            $swatchWrapper
                .toggleClass('cc-orderAgain-modal__colorSwatch--selected', attrValue.selected)
                .attr('aria-selected', attrValue.selected ? 'true' : 'false')
                .attr('aria-disabled', (attrValue.selectable || attrValue.isSoldout || false) ? 'false' : 'true');

            // Update selectable color swatches + link ARIA + roving tabindex
            const $link = $swatchWrapper.find('.js-orderAgain-modal__colorSwatch-link');
            $link.toggleClass('selectable', (attrValue.selectable || attrValue.isSoldout || false))
                .attr('aria-selected', attrValue.selected ? 'true' : 'false')
                .attr('aria-disabled', attrValue.selectable && !attrValue.isSoldout ? 'false' : 'true')
                .attr('tabindex', attrValue.selected ? '0' : '-1');

            $link.data('url', attrValue.variationUrl || '')
                .attr('data-url', attrValue.variationUrl || '');
        }

        // Init swatch carousel after updating swatches
        const $colorCarousel = $(modal.modalBox).find('.js-colorSwatches-carousel');
        if ($colorCarousel.length) {
            if ($colorCarousel.hasClass('slick-initialized')) {
                $colorCarousel.slick('refresh');
            } else {
                this._initColorSwatchesCarousel(modal);
            }
        }
    }

    _updateModalSizeOptions (modal, product, attr) {
        let isSizeSelected = false;

        // Reset size unavailable label
        $(modal.modalBox).find('[data-product-attr="sizeUnavailable"]').addClass('hide');

        for (let j = 0; j < attr.values.length; j++) {
            let attrValue = attr.values[j];

            // Update selected size label
            if (attrValue.selected) {
                $(modal.modalBox).find(`[data-product-attr="selectedSize"]`).text(attrValue.displayValue);
                isSizeSelected = attrValue.selectable;

                // Show size unavailable label
                if (!isSizeSelected && product.orderAgainData && product.orderAgainData.unavailableSizeMessage) {
                    $(modal.modalBox).find('.js-orderAgain-modal__sizeUnavailable-message').text(product.orderAgainData.unavailableSizeMessage);
                    $(modal.modalBox).find('[data-product-attr="sizeUnavailable"]').removeClass('hide');
                }
            }

            let sizeValue = attrValue.value.replace(/\//g, '\\/');
            let $sizeElement = $(modal.modalBox).find(`[data-product-attr="size"][data-attr-value="${sizeValue}"]`);

            // Update current size option selection
            $sizeElement.toggleClass('cc-orderAgain-modal__sizeOption-link--selected', attrValue.selected && attrValue.selectable);

            // Update size options url
            $sizeElement.data('url', attrValue.variationUrl || '').attr('data-url', attrValue.variationUrl || '');

            // Update selectable size options
            $sizeElement.toggleClass('selectable', attrValue.selectable);

            // Update unselectable class
            $sizeElement.toggleClass('unselectable', !attrValue.selectable);

            // Update notify me bell visibility
            $sizeElement.find('.js-orderAgain-modal__sizeOption-unavailableIcon').toggleClass('hide', attrValue.selectable);

            // Update hide class for disabled sizes
            $sizeElement.closest('.js-orderAgain-modal__sizeOption').toggleClass('hide', attrValue.disabled || false);
        }

        // Toggle button disabled state
        $(modal.modalBox).find('[data-product-attr="addToCartButton"]')
            .toggleClass('disabled', !isSizeSelected)
            .prop('disabled', !isSizeSelected);
    }

    _showNotifyMeModal ($currentTarget, notifyMeUrl, modal) {
        if (!$currentTarget || !notifyMeUrl) {
            return;
        }

        const variationUrl = $currentTarget.data('url');
        if (!variationUrl) {
            return;
        }

        const params = variationUrl.split('?')[1] || '';
        notifyMeUrl += '?' + params;

        const selectedSize = $currentTarget.data('attr-value') || '';
        notifyMeUrl = appendToUrl(notifyMeUrl, {
            selectedSize: selectedSize
        });

        $.spinner().start();
        $.ajax(notifyMeUrl).then((data) => {
            $.spinner().stop();
            if (!data) {
                return;
            }

            const notifyMeModal = newModalFromString(data, false, ['cc-notifyMe-modal'], null);
            NotifyHelper.initModal(notifyMeModal);
            Plugins.init();
            $(notifyMeModal.modalBox).addClass('rightModalAttribute');

            modal.close();
            notifyMeModal.open();

            $(notifyMeModal.modalBox).find('.js-modal-close').on('click', () => {
                notifyMeModal.close();
            });
        });
    }

    _initColorSwatchesCarousel (modal) {
        const $carousel = $(modal.modalBox).find('.js-colorSwatches-carousel');
        if (!$carousel.length) {
            return;
        }

        const $prev = $(modal.modalBox).find('.js-colorSwatches-prev');
        const $next = $(modal.modalBox).find('.js-colorSwatches-next');

        $carousel.slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            draggable: true,
            swipe: true,
            touchMove: true,
            accessibility: true,
            responsive: [
                {
                    // Large tablet: allow partial drag if desired
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 7,
                        swipe: true,
                        draggable: true,
                        touchMove: true,
                        swipeToSlide: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 7,
                        swipe: true,
                        draggable: true,
                        touchMove: true,
                        swipeToSlide: true,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        swipe: true,
                        draggable: true,
                        touchMove: true,
                        swipeToSlide: true,
                    },
                },
            ],
        });

        const updateArrowStates = () => {
            if (!$carousel.hasClass('slick-initialized')) return;
            const slick = $carousel.slick('getSlick');
            const current = slick.currentSlide;
            const lastIndex = slick.slideCount - slick.options.slidesToShow;
            $prev.prop('disabled', current <= 0);
            $next.prop('disabled', lastIndex >= 0 ? current >= lastIndex : true);
            const bothDisabled = $prev.prop('disabled') && $next.prop('disabled');
            const $controls = $(modal.modalBox).find('.cc-orderAgain-modal__colorSwatchesControls');
            $controls.toggleClass('hide', bothDisabled).attr('aria-hidden', bothDisabled ? 'true' : 'false');
        };

        $prev.off('click.colorSwatches').on('click.colorSwatches', () => {
            $carousel.slick('slickPrev');
            updateArrowStates();
        });
        $next.off('click.colorSwatches').on('click.colorSwatches', () => {
            $carousel.slick('slickNext');
            updateArrowStates();
        });

        $carousel.on('afterChange', updateArrowStates);
        updateArrowStates();
    }

    _updateQuantity ($quantityContainer, $quantitySelectInput, newQuantity) {
        const url = $quantitySelectInput.find('option[value="' + newQuantity + '"]').data('url');
        if (!url) {
            return;
        }

        $.spinner().start();
        $.ajax(url).then((data) => {
            $.spinner().stop();
            if (!data || !data.product) {
                return;
            }

            // Update displayed quantity label
            $quantityContainer.find('.quantity-value').text(newQuantity);

            // Update hidden select input
            if (data.product.quantities) {
                const optionsHtml = data.product.quantities.map((quantity) => {
                    const selected = quantity.selected ? 'selected' : '';
                    return `<option value="${quantity.value}" data-url="${quantity.url}" ${selected}>${quantity.value}</option>`;
                }).join('');
                $quantitySelectInput.empty().html(optionsHtml);
            }

            // Quantity threshold check to disable buttons
            if (newQuantity === 1) {
                $quantityContainer.find('.quantity-circle[data-action="decrease"]').addClass('disabled');
            } else if (newQuantity === 10) {
                $quantityContainer.find('.quantity-circle[data-action="increase"]').addClass('disabled');
            } else {
                $quantityContainer.find('.quantity-circle').removeClass('disabled');
            }
        });
    }

    loadOrderDetailsButtons (url, $orderDetailsItems) {
        const products = [];
        $orderDetailsItems.each((index, element) => {
            products.push({
                pid: String($(element).data('pid')) || '',
                uuid: String($(element).data('uuid')) || '',
                position: parseInt($(element).data('position')) || 0
            });
        });

        $.ajax({
            url: url,
            method: 'POST',
            data: {
                data: JSON.stringify(products)
            },
            success: (data) => {
                if (!data || !data.result) {
                    return;
                }
                for (let i = 0; i < data.result.length; i++) {
                    let result = data.result[i];
                    let $itemContainer = $(`${this.orderAgainClassOrderDetailsItem}[data-uuid="${result.uuid}"]`);
                    $itemContainer.html('').append(result.html || '');

                    let $productAnalytics = $itemContainer.closest('.js-orderDetails-productInfo').find('.analytics.productListingItem');
                    let itemListName = result.seeSimilar ? 'similar_products' : 'buy_it_again';
                    let itemListId = 'my_orders_and_returns';
                    $productAnalytics
                        .data('item_list_name', itemListName)
                        .attr('data-item_list_name', itemListName);
                    $productAnalytics
                        .data('item_list_id', itemListId)
                        .attr('data-item_list_id', itemListId);
                }

                $('body').trigger('listing:orderDetailsItems', {
                    container: '.js-orderDetails-products__container',
                    type: 'buy_it_again'
                });
            }
        });
    }

    orderAgainPageListeners () {
        const _self = this;
        // Radio buttons listener (dropdown with radio buttons behaviour)
        $('body').on('change', 'input[name="orderAgainFilter"]', (e) => {
            e.preventDefault();

            const $radio = $(e.currentTarget);
            const url = $radio.data('url');
            if (!url) {
                return;
            }

            $.spinner().start();
            $.ajax(url).then((data) => {
                $.spinner().stop();
                $(_self.orderAgainClassProductsContainer).html(data.html || '');
                $('.js-orderAgain-page__viewAllProductsNumber').text(data.totalProductsLabel || '');

                const labelText = $radio.closest('label').find('.radio-label').text().trim();
                $('.js-orderAgain-filter__select').find('.js-orderAgain-selectedLabel').text(labelText);
                // Close the filter on user selection
                const $dropdown = $radio.closest('.cc-orderAgain-page__filtersRadioButton');
                const $filtersBody = $dropdown.find('.cc-orderAgain-page__filtersBody');
                $dropdown.removeClass('cc-orderAgain-page__filtersRadioButton--open').attr('aria-expanded', 'false');
                $filtersBody.attr('aria-hidden', 'true');
                $(document).off('click.orderAgainOutside');
            });
        });

        // Toggle filters body visibility on button click
        $('body').on('click', '.cc-orderAgain-page__filtersRadioButton.js-orderAgain-filter__select', function (e) {
            if ($(e.target).closest('.cc-orderAgain-page__filtersBody').length) {
                return;
            }
            const $button = $(this);
            const $filters = $button.find('.cc-orderAgain-page__filtersBody');
            const isOpen = $button.hasClass('cc-orderAgain-page__filtersRadioButton--open');

            const openFiltersDropdown = () => {
                $button.addClass('cc-orderAgain-page__filtersRadioButton--open').attr('aria-expanded', 'true');
                $filters.attr('aria-hidden', 'false');
            };
            const closeFiltersDropdown = () => {
                $button.removeClass('cc-orderAgain-page__filtersRadioButton--open').attr('aria-expanded', 'false');
                $filters.attr('aria-hidden', 'true');
                $(document).off('click.orderAgainOutside');
            };

            if (!isOpen) {
                e.stopPropagation();
                openFiltersDropdown();
                $(document).on('click.orderAgainOutside', (event) => {
                    if ($(event.target).closest('.cc-orderAgain-page__filtersRadioButton.js-orderAgain-filter__select').length === 0) {
                        closeFiltersDropdown();
                    }
                });
            } else {
                e.stopPropagation();
                closeFiltersDropdown();
            }
        });
    }

    initFilterSelectionLabel () {
        const $container = $('.js-orderAgain-filter__select');
        if (!$container.length) return;
        let $checked = $container.find('input[name="orderAgainFilter"]:checked');
        if (!$checked.length) {
            $checked = $container.find('input[name="orderAgainFilter"]').first();
            $checked.prop('checked', true).attr('checked', 'checked');
        }
        const labelText = $checked.closest('label').find('.radio-label').text().trim();
        $container.find('.js-orderAgain-selectedLabel').text(labelText);
    }

    showCartTab (url) {
        const _self = this;
        $.ajax(url).then((data) => {
            if (data && data.hasPurchasedProducts && data.hasPurchasedProducts === true) {
                $('.js-orderAgain-cartTab__container').removeClass('hide');
                _self._addCartTabListeners();
            }
        });
    }

    _addCartTabListeners () {
        const _self = this;
        $('body').on('click', this.orderAgainClassCartTabItemLink, (e) => {
            e.preventDefault();

            const targetPage = $(e.currentTarget).data('target');
            if (!targetPage) {
                return;
            }

            // Update active tab value
            $(e.currentTarget).closest('.cc-orderAgain-cartTab__item').addClass('cc-orderAgain-cartTab__item--active')
                .siblings().removeClass('cc-orderAgain-cartTab__item--active');

            // Display tab content
            const url = $(e.currentTarget).data('href');
            const isContentLoaded = $(e.currentTarget).data('loaded') || false;
            _self._showTabContent(targetPage, url, isContentLoaded);
        });
    }

    _showTabContent (target, url = null, isContentLoaded = false) {
        const showBuyAgainPage = target === 'buyAgain';
        const showCartPage = target === 'cart';

        if (showBuyAgainPage) {
            if (isContentLoaded) {
                $('.js-cartPage__buyAgainContainer').removeClass('hide');
                $('.js-cartPage__mainContainer').addClass('hide');
                $('.js-cartPage__pageTitle').addClass('hide');
                this.initFilterSelectionLabel();

                $('body').trigger('listing:orderAgainItems', {
                    container: this.orderAgainClassCartCarouselContainer,
                    type: 'buy_it_again'
                });
            } else {
                $.ajax(url).then((data) => {
                    if (data) {
                        $('.js-cartPage__buyAgainContainer').html(data).removeClass('hide');
                        $('.js-cartPage__mainContainer').addClass('hide');
                        $('.js-cartPage__pageTitle').addClass('hide');
                        $(`.js-orderAgain-cartTab__item-link[data-target="buyAgain"]`).data('loaded', true).attr('data-loaded', true);
                        this.initFilterSelectionLabel();

                        $('body').trigger('listing:orderAgainItems', {
                            container: this.orderAgainClassCartCarouselContainer,
                            type: 'buy_it_again'
                        });
                    }
                });
            }
        } else if (showCartPage) {
            $('.js-cartPage__buyAgainContainer').addClass('hide');
            $('.js-cartPage__mainContainer').removeClass('hide');
            $('.js-cartPage__pageTitle').removeClass('hide');
        }
    }

    addProductDetailsListeners ($container, url) {
        this._loadProductDetailsPreviouslyPurchasedSizeLabel($container, url);

        const _self = this;
        $('body').on('orderAgain:previouslyPurchasedSizeUpdate', () => {
            _self._loadProductDetailsPreviouslyPurchasedSizeLabel($container, url);
        });
    }

    _loadProductDetailsPreviouslyPurchasedSizeLabel ($container, url) {
        const pid = $container.data('pid');
        if (!pid) {
            return;
        }

        $.ajax({
            url: url,
            data: {
                pid: pid
            }
        }).then((data) => {
            $container.toggleClass('hidden', !data.previouslyPurchasedSizeLabel).html(data.previouslyPurchasedSizeLabel || '');
            $('.js-size-help-info, .js-size-guide').toggleClass('hide', !!data.previouslyPurchasedSizeLabel);

            // Hide "size bay" tool in case of "order it again" label display
            $('#orderAgainHideSizeBayStyle').remove();
            if (data.previouslyPurchasedSizeLabel) {
                const $hideSizeBayTemplate = applyRendering('orderAgainHideSizeBay');
                $('.js-size-help-info').after($hideSizeBayTemplate);
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const orderAgain = new OrderAgain();
    orderAgain.run();
});
